<template>
  <div class="wrap">
    <div class="con">
      <span class="title_A">杭州总部</span>
      <span class="title_B">浙江省杭州市滨江区浦沿街道世融商业中心1幢安洁利总部</span>
      <span class="title_B cl">电话：4001-081-299</span>
      <img class="cl" src="./imgs/connect.png" alt="">
      <p class="tt">了解更多雷小安请下载App</p>
      <img class="img_b" src="./imgs/more.png" alt="">
    </div>
  </div>
</template>

<script>

export default {
  name: "info",
  data() {
    return {
    };
  },
  methods: {
    
  }
};
</script>

<style lang="scss" scoped>
.wrap{
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  .con {
    width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 50px;
    img{
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .img_b{
      margin-bottom: 70px;
    }
    .title_A{
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999;
      margin-top: 50px;
    }
    .title_B{
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999;
      margin-top: 10px;
    }
    .cl {
      margin-bottom: 10px;
    }
    .tt{
      font-size: 32px;
      font-weight: 600;
      text-align: center;
    }
  }
}
</style>
